<template>
  <div v-if="this.$store.state.server">
    <br />
    <br />
    <b-row class="text-center" v-show="this.name != ''">
      <b-col>
        <qrcode-vue :value="name" :size="size" level="H"></qrcode-vue>
      </b-col>
    </b-row>
    <b-row class="text-center" v-show="this.name != ''">
      <b-col>{{name}}</b-col>
    </b-row>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
  components: {
    QrcodeVue
  },
  data() {
    return {
      name: "https://boardgameeveryday.github.io/#/",
      error: "",
      size: 300
    };
  }
};
</script>

<style>
</style>